import { ref, onMounted, onUnmounted } from 'vue'

const defaultFooterInfo = {
  operate: '13911018725',
  security_center: '84377155',
  tourist_service_center: '64529060',
  house_rental_phone: '13681465024',
  house_rental_landline: '010-64529033',
  cultural_activities: '010-64529046'
}

export function useFooterInfo() {
  const footerInfo = ref({ ...defaultFooterInfo })

  // 从 localStorage 加载数据
  const loadFromStorage = () => {
    const stored = localStorage.getItem('footerInfo')
    if (stored) {
      try {
        const parsed = JSON.parse(stored)
        footerInfo.value = { ...defaultFooterInfo, ...parsed }
      } catch (e) {
        console.error('Failed to parse footerInfo from localStorage', e)
      }
    }
  }

  // 监听 localStorage 变化（跨标签页）
  const handleStorageChange = (e) => {
    if (e.key === 'footerInfo') {
      loadFromStorage()
    }
  }

  onMounted(() => {
    loadFromStorage()
    window.addEventListener('storage', handleStorageChange)
  })

  onUnmounted(() => {
    window.removeEventListener('storage', handleStorageChange)
  })

  return { footerInfo }
}
